export enum Role {
  Admin = 'admin',
  Client = 'client',
  User = 'user',
  Customer='customer'
}
